import { UseIsMobile } from 'common/hooks/UseIsMobile';
import { useRouter } from 'common/hooks/useRouter';
import { getCookies } from 'common/method/helper';
import { useEffect } from 'react';
import { DesktopConfirmCode } from './desktop';
import { MobileConfirmCode } from './mobile';

function Otp() {
  const {
    navigate,
    history: { state },
  } = useRouter();
  const mobile = UseIsMobile()

  useEffect(() => {
    const token_id = getCookies();
    if (state.force && !state.temperoryToken) {
      navigate.pushLogin();
    } else if (!state.force && !token_id) {
      navigate.pushLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {
        mobile ?
          <div className="md:hidden">
            <MobileConfirmCode />
          </div>
          :
          <div className="hidden md:block">
            <DesktopConfirmCode />
          </div>
      }
    </div>
  );
}

export default Otp;
